import { useEffect, useState } from 'react';
import api from '../../services/api';

const IDLE_QUEUE = { active: false, waiting: 0 };

const useQueueStatus = busy => {
  const [queue, setQueue] = useState(IDLE_QUEUE);

  useEffect(() => {
    if (!busy) {
      setQueue(IDLE_QUEUE);
      return undefined;
    }
    let cancelled = false;
    const refresh = () => api.get('/aluminium-deals/queue')
      .then(response => { if (!cancelled) setQueue(response.data); })
      .catch(() => {});
    refresh();
    const timer = setInterval(refresh, 3000);
    return () => { cancelled = true; clearInterval(timer); };
  }, [busy]);

  return queue;
};

export default useQueueStatus;
